// import React from 'react';
// import ReactDOM from 'react-dom';
// import App from './App';
// import './index.css';

// ReactDOM.createRoot(document.getElementById('root')).render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

import React from 'react';
import ReactDOM from 'react-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App'; // Your main application component
import { BrowserRouter } from 'react-router-dom';

// Optional: self-hosted assets (install these packages locally)
// npm install @fortawesome/fontawesome-free @fontsource/noto-sans --save
// Then uncomment the imports below to bundle Font Awesome and Noto Sans locally.
// import '@fortawesome/fontawesome-free/css/all.min.css';
// import '@fontsource/noto-sans';

const clientId = '874285330270-2jl30b8h9toamepegtiis8rmminsf7sn.apps.googleusercontent.com'; // Replace with your actual Google client ID

ReactDOM.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={clientId}>
      <BrowserRouter>
      <App />
      </BrowserRouter>
    </GoogleOAuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
